import { render } from "./inwardSkunumber.vue?vue&type=template&id=65277e3f"
import script from "./inwardSkunumber.vue?vue&type=script&lang=js"
export * from "./inwardSkunumber.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__